import { Link } from "react-router-dom";

const Header = () => {
    return (
        <header>
            <Link className="header" to="/">ana edwards</Link>
        </header>
    );
};

export default Header;